import React from "react";

// Shown when a route's lazy() chunk fails to load. The usual cause is a deploy
// landing while a tab is open: the old index references hashed chunks that no
// longer exist, so the import 404s. A reload fetches the new index and fixes it.
// ponytail: a reload button, not auto-retry — retrying a 404 just fails again.
const ChunkErrorFallback = () => (
    <div className="error-wrapper p-4 text-center">
        <h4>This page failed to load.</h4>
        <p className="text-muted">
            The app was likely updated since you opened this tab.
        </p>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload
        </button>
    </div>
);

export default ChunkErrorFallback;
